import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export interface DepositStyleProps {
  small: boolean;
}

export const useDepositStyles = makeStyles((theme: Theme) => ({
  paperProps: {
    // desktop styles
    borderRadius: "10px",
    // mobile styles
    [theme.breakpoints.down("md")]: {
      borderRadius: "0px",
      minHeight: "100%",
      minWidth: "100%",
    },
  },
  container: {
    minHeight: "582px",
    width: "540px",
    maxWidth: "450px",
    // mobile styles
    [theme.breakpoints.down("md")]: {
      width: "100%",
      minWidth: "100%",
    },
  },
  errorContainer: {
    height: "200px",
    width: "450px",

    // mobile styles
    [theme.breakpoints.down("md")]: {
      height: "100%",
      width: "100%",
    },
  },

  pleaseNoteContainer: {
    width: "410px",
    padding: "12px 12px",
    backgroundColor: "#F8F9F9",
    border: "1px solid #002035",
    borderRadius: "8px",

    // mobile styles
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));
